import Header from "@/components/header";
import TagTextArea from "@/components/tagTextArea";

import DiscountGroupInfo from "@/modules/discount/groupInfo/discountGroupInfo";
import { useGetSmsDiscountPlaceHolder } from "@/services/smsPlaceHolders/hooks/useGetSmsDiscountPlaceHolder";
import { Button, Group, Stack, Text, useMantineTheme } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function EditDiscountMessage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [value, setValue] = useState<string>("");
  const theme = useMantineTheme();
  const template = state?.selectedTemplate;

  const { data: placeHolders, isLoading: placeHolderLoading } =
    useGetSmsDiscountPlaceHolder();

  const nextStep = () => {
    navigate(`/dashboard/discount/create`, {
      state: { ...state, text: value },
    });
  };

  return (
    <Stack h="100svh">
      <Header showHome title="ویرایش متن" />
      <Stack px="md">
        <DiscountGroupInfo
          count={state.count || 0}
          title={state?.group?.name || state?.group?.title || ""}
        />
      </Stack>
      <Stack px="md">
        <Group gap="5">
          <Text> قالب انتخابی </Text>
          <IconChevronLeft size={18} color={theme.colors.gray[6]} />
          <Text c="gray.7"> {template?.title}</Text>
        </Group>
      </Stack>
      <Stack
        px="md"
        styles={{
          root: {
            flexGrow: 1,
          },
        }}
      >
        <TagTextArea
          tags={placeHolders || []}
          setValue={setValue}
          defaultValue={template?.text}
          isLoading={placeHolderLoading}
        />
      </Stack>
      <Stack p="md">
        <Button fullWidth size="md" onClick={nextStep}>
          ادامه
        </Button>
      </Stack>
    </Stack>
  );
}

export default EditDiscountMessage;
